export default __webpack_public_path__ + "static/media/Group9233.2428149c.svg";